<app-page-body>
  <!-- header -->

  <app-page-header
    [title]="title"
    [loading]="loading"
    [showAddBtn]="false"
    [showAuditBtn]="false"
    [showRefreshBtn]="false"
    [isForm]="true"
    [showBackBtn]="false"
  >
    <div class="card-toolbar" after-btns>
      <!-- open sendQueue -->
      <page-header-btn
        [name]="
          userSession?.isSuperAdmin() ? 'sendQueue' : 'currentUserSendQueue'
        "
        icon="mdi-email-multiple-outline"
        [title]="
          userSession?.isSuperAdmin()
            ? 'pages.sendQueue.title'
            : 'pages.sendQueue.userTitle'
        "
        btnColor="btn-light"
      ></page-header-btn>

      <!-- open outboxMessages -->
      <page-header-btn
        [name]="
          userSession?.isSuperAdmin()
            ? 'userOutboxMessages'
            : 'currentUserOutboxMessages'
        "
        icon="mdi-inbox-arrow-up"
        [title]="
          userSession?.isSuperAdmin()
            ? 'pages.outboxMessages.title'
            : 'pages.outboxMessages.userTitle'
        "
        btnColor="btn-light-info"
        iconSize="mdi-22px"
      ></page-header-btn>
    </div>
  </app-page-header>

  <!-- content -->
  <div class="app-page-content">
    <!-- form -->
    <form [formGroup]="form" autocomplete="off">
      <div class="row panels-row send-sms-row">
        <!-- part 1 messageInformation-->
        <section
          class="tw-pr-2 tw-pl-0 sm:tw-w-full md:tw-w-full lg:tw-w-full xl:tw-w-1/4 send-sms"
        >
          <fieldset>
            <legend>
              <i class="mdi mdi-message-cog tw-ml-2"></i>

              {{ "common.messageInformation" | translate }}
            </legend>

            <!-- messageInformation -->
            <div class="row">
              <app-sms-body
                [form]="form"
                smsBodyControlName="smsBody"
                senderNumberControlName="senderNumberId"
                [isShowSmsPreview]="true"
                [isAddSignature]="true"
                [isShowSenderNumberId]="true"
                [isAddHeader]="true"
                [sendType]="SendTypes.Single"
                [smsBody]="displaySmsText"
                [senderNumberId]="model.senderNumberId"
                (smsBody)="displaySmsText = $event"
                (finalSmsBody)="model.smsText = $event"
                (senderNumberId)="model.senderNumberId = $event"
                [isCanSendVoice]="false"
                [justTextMessageAllowed]="true"
                (senderNumber)="isCanSendVoice = $event?.isCanSendVoice"
              >
              </app-sms-body>
            </div>
          </fieldset>
        </section>

        <!-- part 2 organizations-->
        <section
          class="tw-pl-1 tw-pr-2 sm:tw-w-full md:tw-w-full lg:tw-w-full xl:tw-w-2/4 send-sms"
        >
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-office-building-cog tw-ml-2"></i>
              {{ "common.organizations" | translate }}
            </legend>

            <div class="row tw-flex flex-column tw-justify-between tw-h-full">
              <div class="tw-w-full">
                <organization-selection-list
                  itemsHeight="tw-h-[30rem]"
                  type="children"
                  searchLabel="messages.searchInOrganizations"
                  [values]="model.targetOrganizationIds"
                  (values)="model.targetOrganizationIds = $event"
                  searchBoxGridClass="sm:tw-w-1/2 xl:tw-w-1/2"
                  responsiveClass="sm:tw-w-1/2 md:tw-w-1/2 lg:tw-w-1/2 xl:tw-w-1/2 2xl:tw-w-1/2"
                >
                </organization-selection-list>
              </div>
            </div>
          </fieldset>
        </section>

        <!-- part 3 sendDateTimeType-->
        <section
          class="tw-pl-1 tw-pr-2 sm:tw-w-full md:tw-w-full lg:tw-w-full xl:tw-w-1/4 send-sms"
        >
          <fieldset class="tw-h-full">
            <legend class="tw-flex-center">
              <i class="mdi mdi-calendar-clock tw-ml-2"></i>
              {{ "common.sendDateTimeType" | translate }}
            </legend>

            <div class="row tw-flex flex-column tw-justify-between tw-h-full">
              <div class="tw-px-1">
                <!-- date time picker -->
                <app-date-time-picker
                  [config]="directDateTimeConfig"
                  (dateTime)="model.sendDateTime = $event"
                >
                </app-date-time-picker>

                <!-- description -->
                <div class="tw-w-full tw-mt-5">
                  <form-textarea
                    class="tw-w-full"
                    label="common.description"
                    [(value)]="model.description"
                    [control]="form?.get('description')"
                    [rows]="1"
                  >
                  </form-textarea>
                </div>

                <!-- isSendWhiteList -->
                <div
                  class="checkbox-section tw-mr-[5px] ltr:tw-ml-[5px] tw-mb-[10px] tw-mt-2"
                >
                  <mat-slide-toggle
                    [(ngModel)]="model.isSendWhiteList"
                    formControlName="isSendWhiteList"
                  >
                    {{ "common.justSendToWhiteList" | translate }}
                  </mat-slide-toggle>
                </div>
              </div>

              <!-- form btns-->
              <div class="tw-flex flex-column tw-mt-2">
                <!-- submit btn -->
                <button
                  type="button"
                  mat-ripple
                  class="btn tw-py-2 tw-mb-1 tw-w-full button-shadow btn-hover-rise"
                  [themeColor]="'btn-gradient'"
                  [disabled]="loading"
                  (click)="onSubmit()"
                >
                  <ng-container *ngIf="!loading">
                    <!-- send sms -->
                    <ng-container>
                      {{ "common.sendSms" | translate }}
                      <i class="fas fa-paper-plane tw-text-2xl"></i>
                    </ng-container>
                  </ng-container>

                  <!-- loading -->
                  <ng-container *ngIf="loading">
                    <span
                      class="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  </ng-container>
                </button>
              </div>
            </div>
          </fieldset>
        </section>
      </div>
    </form>
  </div>
</app-page-body>
